import * as yup from "yup";
import {numberNatural} from "yup/defaultValudations";

export const schema = yup.object().shape({
  contractPrice: numberNatural(),
});
